import { render, staticRenderFns } from "./quesGuide4.vue?vue&type=template&id=120680ac"
import script from "./quesGuide4.vue?vue&type=script&lang=js"
export * from "./quesGuide4.vue?vue&type=script&lang=js"
import style0 from "./quesGuide4.vue?vue&type=style&index=0&id=120680ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports